import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';

import { types as orderActionTypes } from 'state/order';

import actions from 'state/direct-order-recurring/repeated-from/actionCreators';
import initialState from 'state/direct-order-recurring/repeated-from/initial.state';

const repeatedFrom = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [orderActionTypes.cleanRepeatAndEditing$]: () => initialState,
    [actions.setRepeatedFrom]: (state, { payload: { orderId } }) => orderId,
  },
  initialState
);

export default repeatedFrom;
